import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_network_graph = _resolveComponent("v-network-graph")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_v_network_graph, {
      nodes: _ctx.nodes,
      edges: _ctx.edges,
      configs: _ctx.configs,
      layouts: _ctx.layouts,
      "event-handlers": _ctx.eventHandlers
    }, null, 8, ["nodes", "edges", "configs", "layouts", "event-handlers"])
  ]))
}